import { useEffect, useState } from 'react'

import { localeCorrente } from '../i18n/lingua'

/**
 * The clock of the wall displays, **on its own**.
 *
 * It ticks every second; when the tick lived in the page's state, the whole
 * page re-rendered every second — the dashboard was recomputed, and with the
 * default one (never saved) that meant new widget ids every second, so every
 * widget was unmounted, mounted and reloaded again and again: the wall
 * blinked. Here the second changes only this span.
 */
export function Orologio({ className = 'sinottico__ora' }: { className?: string }) {
  const [ora, setOra] = useState(() => new Date())
  useEffect(() => {
    const id = window.setInterval(() => setOra(new Date()), 1000)
    return () => window.clearInterval(id)
  }, [])
  return (
    <span className={className}>
      {ora.toLocaleTimeString(localeCorrente(), { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
    </span>
  )
}
